/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ScheduleWindow } from './scheduleWindow';

/**
 * Body for ``PATCH /api/org/outreach-settings``.
 */
export interface OrgOutreachSettingsRequest {
  default_timezone?: string | null;
  default_schedule_windows?: ScheduleWindow[] | null;
  default_skip_holidays?: boolean | null;
}
